export const FACILITY_FILTER_TYPE = 1;
export const SPECIALTY_FILTER_TYPE = 2;
export const SHIFT_FILTER_TYPE = 5;

export const UNFILLED_ID = 1;
export const FILLED_ID = 2;
export const HAITUS_ID = 3;

export const ALL_OPEN_ID = 1;
export const OPEN_TRAVEL_ID = 2;
export const OPEN_LICENSING_ID = 3;
export const OPEN_CREDENTIALING_ID = 4;
export const ALL_LOGISTICS_ID = 5;

export const facilityUserFilterTypes = {
  [FACILITY_FILTER_TYPE]: {
    id: FACILITY_FILTER_TYPE,
    name: 'Facility',
    isSelected: true,
    searchAPI: '/api/facilities/search?facilityNameLike=',
    conditionResponseData: function (responseData: any) {
      return responseData.map((responseObject: any) => {
        responseObject.filterTypeId = FACILITY_FILTER_TYPE;
        return responseObject;
      });
    }
  },
  [SPECIALTY_FILTER_TYPE]: {
    id: SPECIALTY_FILTER_TYPE,
    name: 'Specialty',
    isSelected: false,
    searchAPI:'/api/specialties/search?specialtyNameLike=',
    conditionResponseData: function(responseData:any){
      return responseData.map((responseObject:any) => {
        responseObject.name = responseObject.specialty;
        responseObject.filterTypeId = SPECIALTY_FILTER_TYPE;
        return responseObject;
      });
    }
  },
  [SHIFT_FILTER_TYPE]: {
    id: SHIFT_FILTER_TYPE,
    name: 'Shifts',
    searchEnum: [
      {
        id: UNFILLED_ID,
        name: 'Only Unfilled shifts',
        filterTypeId: SHIFT_FILTER_TYPE
      },
      {
        id: FILLED_ID,
        name: 'Only Filled Shifts',
        filterTypeId: SHIFT_FILTER_TYPE
      }
    ]
  }
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/enums/CalendarFacilityUserFilterTypes.ts